module.exports = __webpack_public_path__ + "media/images/lb/276-e80a7a7bde932df0b1beaf05a73f855c.svg";